import React from 'react'
import { useTranslation } from 'react-i18next'
import { Col } from '../../../../../packages/kiti/components/structure/Grid'
import FormItem from '../../../../../packages/kiti/components/form/form/FormItem'
import Textarea from '../../../../../packages/kiti/components/form/Textarea'

const EditWidgetForm = () => {
  const { t } = useTranslation('common')

  return (
    <>
      <Col width="100%">
        <FormItem label={t('widgets.url')} path={['data', 'src']} Input={Textarea} />
      </Col>
    </>
  )
}

export default EditWidgetForm
